import { bridge, esappBridge, hydriverBridge } from '../../../index';
import { weixinReady, alimpReady, dympReady, webappReady } from '../index';
import { xposParamsMap, build, buildUrl, handleParams, appidMap, appidMapAlipay, appIdSourceMap, changeHostToHK, } from '@didi/webx-js-core';
import { addJumpH5CommonParams, getNineChapterCommonParams, getNineChapterGotoParams, getNineChapterSameProductGotoParams, getNineChapterShareParams } from '../../../../statistic';
import { xenv } from '../../../../xenv';
import { getOmega } from '../../../../omega';
import { utils } from '../../../../utils';
import { isHK } from '../../../../xenv';
import { query, parseURL } from '../../../../query';
/* jump中间件 */
/* 用于进行统一的format和参数注入工作 */
class JumpMiddleware {
    constructor(context) {
        let { loadParams, params } = context;
        this.loadParams = loadParams;
        this.params = params;
        context.getNineChapterParams = (this.loadParams.extParams && this.loadParams.extParams.sameProduct) ? getNineChapterSameProductGotoParams : getNineChapterGotoParams; // eslint-disable-line
        this.injectXspm();
        this.injectXpos();
    }
    /* 注入xspm_from */
    injectXspm() {
        if (this.loadParams.extParams && this.loadParams.extParams.xspmInfo) {
            if (utils.isObj(this.loadParams.extParams.xspmInfo && Object.keys(this.loadParams.extParams.xspmInfo).length > 0 && getOmega())) {
                this.params['xspm_from'] = getOmega().formatSpmPath ? getOmega().formatSpmPath({ a: getNineChapterCommonParams()['prod_key'], ...this.loadParams.extParams.xspmInfo }) : '';
            }
        }
    }
    /* 注入xpos_from */
    injectXpos() {
        if (this.loadParams.extParams && utils.isObj(this.loadParams.extParams.resourceInfo)) {
            let resourceInfo = this.loadParams.extParams.resourceInfo;
            /* 检查必填项 */
            const pass = this.getArrEqual(['resname', 'element_name', 'xspm'], Object.keys(resourceInfo));
            if (pass) {
                /* 默认绑定当前prod_key */
                if (!resourceInfo['prod_key']) {
                    const collection = getNineChapterCommonParams();
                    resourceInfo['prod_key'] = collection['prod_key'];
                }
                /* xpos参数映射 */
                resourceInfo = Object.entries(resourceInfo).reduce((res, [key, value]) => {
                    if (xposParamsMap[key]) { // 需要映射 进行key转换
                        res[xposParamsMap[key]] = value;
                    }
                    else {
                        res[key] = value;
                    }
                    return res;
                }, {});
                this.params['xpos_from'] = encodeURIComponent(JSON.stringify(resourceInfo));
                /* 有xpos 没有xpsm的场景下 默认使用xpos.xspm填充xspm */
                if (!this.params['xspm_from'] && resourceInfo['xp']) {
                    this.params['xspm_from'] = getOmega().formatSpmPath ? getOmega().formatSpmPath({ a: resourceInfo['pk'], c: resourceInfo['xp'], d: resourceInfo['idx'] }) : '';
                }
            }
        }
    }
    getArrEqual(arr1, arr2) {
        return arr1.reduce((list, item1) => {
            if (arr2.find((item2) => item1 === item2))
                list.push(item1);
            return list;
        }, []);
    }
}
class JumpBase {
    constructor(loadParams, xenv, commonParams) {
        this.appidMap = appidMap;
        this.appidMapAlipay = appidMapAlipay;
        this.appIdSourceMap = appIdSourceMap;
        this.loadParams = loadParams;
        this.xenv = xenv;
        this.params = commonParams;
        this.getNineChapterParams = getNineChapterGotoParams;
        /* 香港地区统一更换host */
        if (isHK) {
            if ('url' in this.loadParams && this.loadParams.url) {
                this.loadParams = {
                    ...this.loadParams,
                    url: changeHostToHK(this.loadParams.url)
                };
            }
        }
    }
    doJump() { }
}
// commonJump
class H5Jump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('scheme' in this.loadParams && this.loadParams.scheme) {
            this.scheme(this.loadParams.scheme, extParams);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
            return;
        }
    }
    scheme(scheme, extParams) {
        const finalScheme = extParams && extParams.injectNineChapterParams === false
            ? buildUrl(scheme, this.params)
            : buildUrl(scheme, Object.assign({}, this.getNineChapterParams({ removeXoid: true }), this.params));
        window.location.href = finalScheme;
    }
    url(url, extParams) {
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, this.params)
            : build(url, Object.assign({}, this.getNineChapterParams(), this.params));
        window.location.href = finalUrl;
    }
}
class PassengerJump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('originalAppId' in this.loadParams &&
            'path' in this.loadParams &&
            this.loadParams.originalAppId &&
            this.loadParams.path) {
            this.path(this.loadParams.path, null, this.loadParams.originalAppId, extParams);
            return;
        }
        if ('scheme' in this.loadParams && this.loadParams.scheme) {
            this.scheme(this.loadParams.scheme, extParams);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
            return;
        }
        if ('path' in this.loadParams &&
            'appId' in this.loadParams &&
            this.loadParams.path &&
            this.loadParams.appId) {
            this.path(this.loadParams.path, this.loadParams.appId, null, extParams);
            return;
        }
    }
    isNaScheme(origin_scheme = '') {
        const { protocol, hostAndPath } = parseURL(origin_scheme);
        const _scheme_without_params = protocol + hostAndPath;
        const _scheme = _scheme_without_params.toLowerCase();
        const regExpList = [
            /onetravel:\/\/(.*)entrance/i,
            /onetravel:\/\/(.*)rebound/i
        ];
        const found = regExpList.some(regExp => regExp.test(_scheme));
        return found;
    }
    scheme(scheme, extParams) {
        let schemeJumpMethod = extParams && extParams.schemeJumpMethod ? extParams.schemeJumpMethod : '';
        /* 兼容顺风车页面的特殊scheme diditravel://com.didi.passengerapp/beatles_homepage?productid=259&userrole=2&refresh=1 */
        if (/^diditravel/g.test(scheme)) {
            bridge.openPage({
                url: scheme,
                target: 'native'
            });
            return;
        }
        if (schemeJumpMethod === 'switchToBusinessPage' || this.isNaScheme(scheme)) {
            console.log('=== 命中乘客端scheme 将使用switchToBusinessPage跳转 ===', scheme);
            bridge.switchToBusinessPage({
                navi_url: scheme
            }, () => { });
            return;
        }
        const finalScheme = extParams && extParams.injectNineChapterParams === false
            ? build(scheme, this.params)
            : build(scheme, Object.assign({}, this.getNineChapterParams({ removeXoid: true }), this.params));
        bridge.openPage({
            url: finalScheme,
            target: extParams && extParams.openPageTarget ? extParams.openPageTarget : ''
        });
    }
    url(url, extParams) {
        let h5JumpMethod = extParams && extParams.h5JumpMethod ? extParams.h5JumpMethod : 'openPage';
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, this.params)
            : build(url, Object.assign({}, this.getNineChapterParams(), this.params));
        if (h5JumpMethod === 'href') {
            window.location.href = finalUrl;
        }
        else {
            bridge.openPage({
                url: finalUrl
            });
        }
    }
    path(path, appId, appIdSource, extParams) {
        let programType = extParams && extParams.programType ? extParams.programType : 0;
        if (!appIdSource) {
            appIdSource = this.appIdSourceMap[appId] || appId;
        }
        let pagepath = `${/^\//.test(path) ? '' : '/'}${path}`;
        const finalPath = extParams && extParams.injectNineChapterParams === false
            ? build(pagepath, this.params)
            : build(pagepath, Object.assign({}, this.getNineChapterParams(), this.params));
        bridge.launchWeChatMiniApp({
            appId: appIdSource,
            path: finalPath,
            programType: programType
        });
    }
}
class DriverJump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('scheme' in this.loadParams && this.loadParams.scheme) {
            this.scheme(this.loadParams.scheme);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
            return;
        }
    }
    url(url, extParams) {
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, this.params)
            : build(url, Object.assign({}, this.getNineChapterParams(), this.params));
        window.location.href = finalUrl;
    }
    scheme(scheme) {
        window.location.href = build(scheme, this.params);
    }
}
class HyDriverJump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('scheme' in this.loadParams && this.loadParams.scheme) {
            this.scheme(this.loadParams.scheme, extParams);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
        }
    }
    scheme(scheme, extParams) {
        const finalScheme = extParams && extParams.injectNineChapterParams === false
            ? build(scheme, this.params)
            : build(scheme, Object.assign({}, this.getNineChapterParams({ removeXoid: true }), this.params));
        hydriverBridge.callHandler('openPage', {
            url: finalScheme,
            target: extParams && extParams.openPageTarget ? extParams.openPageTarget : 'self'
        });
    }
    url(url, extParams) {
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, this.params)
            : build(url, Object.assign({}, this.getNineChapterParams(), this.params));
        hydriverBridge.callHandler('openPage', {
            url: finalUrl,
            target: extParams && extParams.openPageTarget ? extParams.openPageTarget : 'self'
        });
    }
}
class EsAppJump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('scheme' in this.loadParams && this.loadParams.scheme) {
            this.scheme(this.loadParams.scheme, extParams);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
            return;
        }
        if ('path' in this.loadParams &&
            'appId' in this.loadParams &&
            this.loadParams.path &&
            this.loadParams.appId) {
            this.path(this.loadParams.path, this.loadParams.appId, extParams);
            return;
        }
    }
    url(url, extParams) {
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, this.params)
            : build(url, Object.assign({}, this.getNineChapterParams(), this.params));
        window.location.href = finalUrl;
    }
    scheme(scheme, extParams) {
        const finalScheme = extParams && extParams.injectNineChapterParams === false
            ? build(scheme, this.params)
            : build(scheme, Object.assign({}, this.getNineChapterParams({ removeXoid: true }), this.params));
        esappBridge.openPage({
            url: finalScheme,
            target: extParams && extParams.openPageTarget ? extParams.openPageTarget : ''
        });
    }
    path(path, appId, extParams) {
        let programType = extParams && extParams.programType ? extParams.programType : 0;
        let appIdSource = this.appIdSourceMap[appId] || appId;
        let pagepath = `${/^\//.test(path) ? '' : '/'}${path}`;
        const finalPath = extParams && extParams.injectNineChapterParams === false
            ? build(pagepath, this.params)
            : build(pagepath, Object.assign({}, this.getNineChapterParams(), this.params));
        esappBridge.launchWeChatMiniApp({
            appId: appIdSource,
            path: finalPath,
            programType: programType
        });
    }
}
class WeixinJump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('scheme' in this.loadParams && this.loadParams.scheme) {
            this.scheme(this.loadParams.scheme);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
            return;
        }
    }
    url(url, extParams) {
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, this.params)
            : build(url, Object.assign({}, this.getNineChapterParams(), this.params));
        window.location.href = finalUrl;
    }
    scheme(scheme) {
        window.location.href = build(scheme, this.params);
    }
}
class AlipayJump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('scheme' in this.loadParams && this.loadParams.scheme) {
            this.scheme(this.loadParams.scheme);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
        }
    }
    url(url, extParams) {
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, this.params)
            : build(url, Object.assign({}, this.getNineChapterParams(), this.params));
        window.location.href = finalUrl;
    }
    scheme(scheme) {
        window.location.href = build(scheme, this.params);
    }
}
class DouyinJump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('scheme' in this.loadParams && this.loadParams.scheme) {
            this.scheme(this.loadParams.scheme);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
            return;
        }
    }
    url(url, extParams) {
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, this.params)
            : build(url, Object.assign({}, this.getNineChapterParams(), this.params));
        window.location.href = finalUrl;
    }
    scheme(scheme) {
        window.location.href = build(scheme, this.params);
    }
}
class MiniprogramJump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        console.log('=== wx MiniprogramJump ===', this.loadParams);
        weixinReady(this.wxCb.bind(this));
    }
    wxCb(sdk) {
        if (sdk instanceof Error || !window.wx) {
            // 成功的情况下window.wx 跟 sdk等价
            console.log('wx jssdk 加载失败');
            window?.Omega?.trackError('webx-js error', 5001, 'goTo执行失败', {
                cdn: 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js',
                xenv: xenv(),
                package: 'web',
                desc: sdk instanceof Error ? 'goTo因CDN加载失败而执行失败' : 'goTo因wx对象不存在而执行失败',
            });
            return;
        }
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('path' in this.loadParams && this.loadParams.path) {
            if ('appId' in this.loadParams &&
                this.loadParams.appId &&
                this.appidMap[this.xenv] !== this.loadParams.appId) {
                this.miniprogram(sdk, this.loadParams.path, this.loadParams.appId, extParams);
                return;
            }
            this.path(sdk, this.loadParams.path, extParams);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
            return;
        }
        if ('activityId' in this.loadParams && this.loadParams.activityId) {
            this.middleware(sdk, this.loadParams.activityId, extParams);
            return;
        }
        if ('type' in extParams &&
            (extParams.type === 'login' ||
                extParams.type === 'share')) {
            let activityId = 'activityId' in this.loadParams ? this.loadParams.activityId : '';
            this.middleware(sdk, activityId, extParams);
            return;
        }
    }
    miniprogram(sdk, path, appId, extParams) {
        let pagepath = buildUrl(`${/^\//.test(path) ? '' : '/'}${path}`, this.params);
        const finalPath = extParams && extParams.injectNineChapterParams === false
            ? pagepath
            : build(pagepath, this.getNineChapterParams());
        let jumpUrl = `/webx-mp-next/transfer-station/index?type=jump&jump_appid=${appId}&jump_path=${encodeURIComponent(finalPath)}`;
        sdk.miniProgram.navigateTo({
            url: jumpUrl,
            success() {
                console.log('拉取中间页成功');
            },
            fail(err) {
                console.log('拉取中间页失败', err);
            }
        });
    }
    path(sdk, path, extParams) {
        let pagepath = '';
        if (/pages\/webview-page\/index/.test(path)) {
            const nativeParams = handleParams(path);
            const h5Url = decodeURIComponent(nativeParams.url);
            delete nativeParams.url;
            delete nativeParams.need_login;
            // 把剩余的参数也拼到 h5 链接上
            pagepath = buildUrl(h5Url, nativeParams);
            const finalUrl = extParams && extParams.injectNineChapterParams === false
                ? buildUrl(pagepath, this.params)
                : build(pagepath, Object.assign({}, this.getNineChapterParams(), this.params));
            window.location.href = finalUrl;
        }
        else {
            pagepath = build(`${/^\//.test(path) ? '' : '/'}${path}`, this.params);
            const finalPath = extParams && extParams.injectNineChapterParams === false
                ? pagepath
                : build(pagepath, Object.assign({}, this.getNineChapterParams(), this.params));
            let to;
            let moveType = 0;
            if (this.loadParams.extParams &&
                'moveType' in this.loadParams.extParams) {
                moveType = this.loadParams.extParams.moveType;
            }
            switch (moveType) {
                case 0:
                    to = 'navigateTo';
                    break;
                case 1:
                    to = 'redirectTo';
                    break;
                case 2:
                    to = 'reLaunch';
                    break;
                default:
                    to = 'navigateTo';
            }
            sdk.miniProgram[to]({
                url: finalPath
            });
        }
    }
    url(url, extParams) {
        if (!query(url)['from']) {
            this.params = {
                from: query().from,
                ...this.params
            };
        }
        const queryData = query(url);
        const h5CommonParams = addJumpH5CommonParams(this.loadParams, queryData, this.params);
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, Object.assign({}, h5CommonParams, queryData, { xenv: xenv() }, this.params), false)
            : build(url, Object.assign({}, h5CommonParams, this.getNineChapterParams(), {
                xenv: xenv()
            }, this.params));
        /* 小程序webview跳转url时 必须携带xenv */
        window.location.href = finalUrl;
    }
    middleware(sdk, activityId, extParams) {
        if (extParams.type === 'share' && !extParams.shareMsg)
            return;
        let backUrl = extParams.backUrl
            ? encodeURIComponent(build(extParams.backUrl, Object.assign({}, { xenv: xenv() })))
            : '';
        let shareMsg = extParams.shareMsg || {};
        let url = '/webx-mp-next/transfer-station/index';
        shareMsg.share_imgUrl = shareMsg.share_imgUrl
            ? encodeURIComponent(shareMsg.share_imgUrl)
            : '';
        shareMsg.share_sharePath = shareMsg.share_sharePath
            ? encodeURIComponent(build(shareMsg.share_sharePath, getNineChapterShareParams()))
            : '';
        shareMsg.share_shareImgUrl = shareMsg.share_shareImgUrl
            ? encodeURIComponent(shareMsg.share_shareImgUrl)
            : '';
        switch (extParams.type) {
            case 'subscribe':
                url =
                    url +
                        `?type=${extParams.type}&activity_id=${activityId}&back_url=${backUrl}`;
                break;
            case 'login':
                url = url + `?type=${extParams.type}&back_url=${backUrl}`;
                break;
            case 'contact':
                url =
                    url +
                        `?type=${extParams.type}&activity_id=${activityId}&back_url=${backUrl}`;
                break;
            case 'share':
                url = build(url + `?type=${extParams.type}&activity_id=${activityId}`, shareMsg);
                break;
            case 'jump':
                url =
                    url +
                        `?type=${extParams.type}&activity_id=${activityId}&back_url=${backUrl}`;
                break;
            default:
                url = url + `?type=jump&activity_id=${activityId}`;
                return;
        }
        sdk.miniProgram.navigateTo({
            url: url,
            success() {
                console.log('拉取中间页成功');
            },
            fail(err) {
                console.log('拉取中间页失败', err);
            }
        });
    }
}
class AliprogramJump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        alimpReady(this.aliCb.bind(this));
    }
    aliCb(sdk) {
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('path' in this.loadParams && this.loadParams.path) {
            console.log('=== ali loadParams ===', this.loadParams);
            if ('appId' in this.loadParams &&
                this.loadParams.appId &&
                this.appidMapAlipay[this.xenv] !== this.loadParams.appId &&
                extParams?.source !== 'from_webx') {
                this.miniprogram(sdk, this.loadParams.path, this.loadParams.appId, extParams);
                return;
            }
            this.path(sdk, this.loadParams.path, extParams);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
            return;
        }
    }
    path(sdk, path, extParams) {
        let pagepath = '';
        if (/pages\/webview-page\/index/.test(path)) {
            const nativeParams = handleParams(path);
            const h5Url = decodeURIComponent(nativeParams.url);
            delete nativeParams.url;
            delete nativeParams.need_login;
            // 把剩余的参数也拼到 h5 链接上
            pagepath = buildUrl(h5Url, nativeParams);
            const finalUrl = extParams && extParams.injectNineChapterParams === false
                ? buildUrl(pagepath, this.params)
                : build(pagepath, Object.assign({}, this.getNineChapterParams(), this.params));
            window.location.href = finalUrl;
        }
        else {
            pagepath = build(`${/^\//.test(path) ? '' : '/'}${path}`, this.params);
            const finalPath = extParams && extParams.injectNineChapterParams === false
                ? pagepath
                : build(pagepath, Object.assign({}, this.getNineChapterParams(), this.params));
            let to;
            let moveType = 0;
            if (this.loadParams.extParams &&
                'moveType' in this.loadParams.extParams) {
                moveType = this.loadParams.extParams.moveType;
            }
            switch (moveType) {
                case 0:
                    to = 'navigateTo';
                    break;
                case 1:
                    to = 'redirectTo';
                    break;
                case 2:
                    to = 'reLaunch';
                    break;
                default:
                    to = 'navigateTo';
            }
            window.my[to]({
                url: finalPath
            });
        }
    }
    miniprogram(sdk, path, appId, extParams) {
        let pagepath = buildUrl(`${/^\//.test(path) ? '' : '/'}${path}`, this.params);
        const finalPath = extParams && extParams.injectNineChapterParams === false
            ? pagepath
            : build(pagepath, this.getNineChapterParams());
        let jumpUrl = `/webx/transfer-station/index?type=jump&jump_appid=${appId}&jump_path=${encodeURIComponent(finalPath)}`;
        window.my.navigateTo({
            url: jumpUrl,
            success() {
                console.log('拉取中间页成功');
            },
            fail(err) {
                console.log('拉取中间页失败', err);
            }
        });
    }
    url(url, extParams) {
        if (!query(url)['from']) {
            this.params = {
                from: query().from,
                ...this.params
            };
        }
        const queryData = query(url);
        const h5CommonParams = addJumpH5CommonParams(this.loadParams, queryData, this.params);
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, Object.assign({}, h5CommonParams, queryData, { xenv: xenv() }, this.params), false)
            : build(url, Object.assign({}, h5CommonParams, this.getNineChapterParams(), {
                xenv: xenv()
            }, this.params));
        /* 小程序webview跳转url时 必须携带xenv */
        window.location.href = finalUrl;
    }
}
class DyprogramJump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        dympReady(this.dyCb.bind(this));
    }
    dyCb(sdk) {
        if (sdk instanceof Error || !window.tt) {
            // 成功的情况下window.tt 跟 sdk等价
            console.log('dy jssdk 加载失败');
            return;
        }
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('path' in this.loadParams && this.loadParams.path) {
            if ('appId' in this.loadParams &&
                this.loadParams.appId &&
                this.appidMap[this.xenv] !== this.loadParams.appId) {
                this.miniprogram(sdk, this.loadParams.path, this.loadParams.appId, extParams);
                return;
            }
            this.path(sdk, this.loadParams.path, extParams);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
            return;
        }
        if ('activityId' in this.loadParams && this.loadParams.activityId) {
            this.middleware(sdk, this.loadParams.activityId, extParams);
            return;
        }
        if ('type' in extParams &&
            (extParams.type === 'login' ||
                extParams.type === 'share')) {
            let activityId = 'activityId' in this.loadParams ? this.loadParams.activityId : '';
            this.middleware(sdk, activityId, extParams);
            return;
        }
    }
    miniprogram(sdk, path, appId, extParams) {
        let pagepath = buildUrl(`${/^\//.test(path) ? '' : '/'}${path}`, this.params);
        const finalPath = extParams && extParams.injectNineChapterParams === false
            ? pagepath
            : build(pagepath, this.getNineChapterParams());
        let jumpUrl = `/webx-mp-next/transfer-station/index?type=jump&jump_appid=${appId}&jump_path=${encodeURIComponent(finalPath)}`;
        sdk.miniProgram.navigateTo({
            url: jumpUrl,
            success() {
                console.log('拉取中间页成功');
            },
            fail(err) {
                console.log('拉取中间页失败', err);
            }
        });
    }
    path(sdk, path, extParams) {
        let pagepath = '';
        if (/pages\/webview-page\/index/.test(path)) {
            const nativeParams = handleParams(path);
            const h5Url = decodeURIComponent(nativeParams.url);
            delete nativeParams.url;
            delete nativeParams.need_login;
            // 把剩余的参数也拼到 h5 链接上
            pagepath = buildUrl(h5Url, nativeParams);
            const finalUrl = extParams && extParams.injectNineChapterParams === false
                ? buildUrl(pagepath, this.params)
                : build(pagepath, Object.assign({}, this.getNineChapterParams(), this.params));
            window.location.href = finalUrl;
        }
        else {
            pagepath = build(`${/^\//.test(path) ? '' : '/'}${path}`, this.params);
            const finalPath = extParams && extParams.injectNineChapterParams === false
                ? pagepath
                : build(pagepath, Object.assign({}, this.getNineChapterParams(), this.params));
            let to;
            let moveType = 0;
            if (this.loadParams.extParams &&
                'moveType' in this.loadParams.extParams) {
                moveType = this.loadParams.extParams.moveType;
            }
            switch (moveType) {
                case 0:
                    to = 'navigateTo';
                    break;
                case 1:
                    to = 'redirectTo';
                    break;
                case 2:
                    to = 'reLaunch';
                    break;
                default:
                    to = 'navigateTo';
            }
            sdk.miniProgram[to]({
                url: finalPath
            });
        }
    }
    url(url, extParams) {
        if (!query(url)['from']) {
            this.params = {
                from: query().from,
                ...this.params
            };
        }
        const queryData = query(url);
        const h5CommonParams = addJumpH5CommonParams(this.loadParams, queryData, this.params);
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, Object.assign({}, h5CommonParams, queryData, { xenv: xenv() }, this.params), false)
            : build(url, Object.assign({}, h5CommonParams, this.getNineChapterParams(), {
                xenv: xenv()
            }, this.params));
        /* 小程序webview跳转url时 必须携带xenv */
        window.location.href = finalUrl;
    }
    middleware(sdk, activityId, extParams) {
        if (extParams.type === 'share' && !extParams.shareMsg)
            return;
        let backUrl = extParams.backUrl
            ? encodeURIComponent(build(extParams.backUrl, Object.assign({}, { xenv: xenv() })))
            : '';
        let shareMsg = extParams.shareMsg || {};
        let url = '/webx-mp-next/transfer-station/index';
        shareMsg.share_imgUrl = shareMsg.share_imgUrl
            ? encodeURIComponent(shareMsg.share_imgUrl)
            : '';
        shareMsg.share_sharePath = shareMsg.share_sharePath
            ? encodeURIComponent(build(shareMsg.share_sharePath, getNineChapterShareParams()))
            : '';
        shareMsg.share_shareImgUrl = shareMsg.share_shareImgUrl
            ? encodeURIComponent(shareMsg.share_shareImgUrl)
            : '';
        switch (extParams.type) {
            case 'subscribe':
                url =
                    url +
                        `?type=${extParams.type}&activity_id=${activityId}&back_url=${backUrl}`;
                break;
            case 'login':
                url = url + `?type=${extParams.type}&back_url=${backUrl}`;
                break;
            case 'contact':
                url =
                    url +
                        `?type=${extParams.type}&activity_id=${activityId}&back_url=${backUrl}`;
                break;
            case 'share':
                url = build(url + `?type=${extParams.type}&activity_id=${activityId}`, shareMsg);
                break;
            case 'jump':
                url =
                    url +
                        `?type=${extParams.type}&activity_id=${activityId}&back_url=${backUrl}`;
                break;
            default:
                url = url + `?type=jump&activity_id=${activityId}`;
                return;
        }
        sdk.miniProgram.navigateTo({
            url: url,
            success() {
                console.log('拉取中间页成功');
            },
            fail(err) {
                console.log('拉取中间页失败', err);
            }
        });
    }
}
class HwfastappJump extends JumpBase {
    constructor(loadParams, xenv, commonParams = {}) {
        super(loadParams, xenv, commonParams);
    }
    doJump() {
        webappReady(this.webappCb.bind(this));
    }
    webappCb() {
        /* 执行 middleware */
        new JumpMiddleware(this);
        /* End 执行 middleware */
        const extParams = this.loadParams.extParams;
        if ('path' in this.loadParams && this.loadParams.path) {
            this.path(this.loadParams.path, extParams);
            return;
        }
        if ('url' in this.loadParams && this.loadParams.url) {
            this.url(this.loadParams.url, extParams);
            return;
        }
        if ('activityId' in this.loadParams && this.loadParams.activityId) {
            this.middleware(this.loadParams.activityId, extParams);
            return;
        }
        if ('type' in extParams &&
            (extParams.type === 'login' ||
                extParams.type === 'share')) {
            let activityId = 'activityId' in this.loadParams ? this.loadParams.activityId : '';
            this.middleware(activityId, extParams);
            return;
        }
    }
    path(path, extParams) {
        let pagepath = '';
        if (/pages\/webview-page\/index/.test(path)) {
            const nativeParams = handleParams(path);
            const h5Url = decodeURIComponent(nativeParams.url);
            delete nativeParams.url;
            delete nativeParams.need_login;
            // 把剩余的参数也拼到 h5 链接上
            pagepath = buildUrl(h5Url, nativeParams);
            const finalUrl = extParams && extParams.injectNineChapterParams === false
                ? buildUrl(pagepath, this.params)
                : build(pagepath, Object.assign({}, this.getNineChapterParams(), this.params));
            window.location.href = finalUrl;
        }
        else {
            pagepath = build(`${/^\//.test(path) ? '' : '/'}${path}`, this.params);
            const finalPath = extParams && extParams.injectNineChapterParams === false
                ? pagepath
                : build(pagepath, Object.assign({}, this.getNineChapterParams(), this.params));
            let to;
            let moveType = 0;
            if (this.loadParams.extParams &&
                'moveType' in this.loadParams.extParams) {
                moveType = this.loadParams.extParams.moveType;
            }
            switch (moveType) {
                case 0:
                    to = 'navigateTo';
                    break;
                case 1:
                    to = 'redirectTo';
                    break;
                case 2:
                    to = 'reLaunch';
                    break;
                default:
                    to = 'navigateTo';
            }
            window.MPXWebviewBridge[to]({
                url: finalPath
            });
        }
    }
    url(url, extParams) {
        if (!query(url)['from']) {
            this.params = {
                from: query().from,
                ...this.params
            };
        }
        const queryData = query(url);
        const h5CommonParams = addJumpH5CommonParams(this.loadParams, queryData, this.params);
        const finalUrl = extParams && extParams.injectNineChapterParams === false
            ? build(url, Object.assign({}, h5CommonParams, queryData, { xenv: xenv() }, this.params), false)
            : build(url, Object.assign({}, h5CommonParams, this.getNineChapterParams(), {
                xenv: xenv()
            }, this.params));
        /* 小程序webview跳转url时 必须携带xenv */
        window.location.href = finalUrl;
        console.log('==============>goTo url', finalUrl);
    }
    middleware(activityId, extParams) {
        if (extParams.type === 'share' && !extParams.shareMsg)
            return;
        let backUrl = extParams.backUrl
            ? encodeURIComponent(build(extParams.backUrl, Object.assign({}, { xenv: xenv() })))
            : '';
        let shareMsg = extParams.shareMsg || {};
        let url = '/webx-mp-next/transfer-station/index';
        shareMsg.share_imgUrl = shareMsg.share_imgUrl
            ? encodeURIComponent(shareMsg.share_imgUrl)
            : '';
        shareMsg.share_sharePath = shareMsg.share_sharePath
            ? encodeURIComponent(build(shareMsg.share_sharePath, getNineChapterShareParams()))
            : '';
        shareMsg.share_shareImgUrl = shareMsg.share_shareImgUrl
            ? encodeURIComponent(shareMsg.share_shareImgUrl)
            : '';
        switch (extParams.type) {
            case 'login':
                url = url + `?type=${extParams.type}&back_url=${backUrl}`;
                break;
            case 'share':
                url = build(url + `?type=${extParams.type}&activity_id=${activityId}`, shareMsg);
                break;
            case 'jump':
                url =
                    url +
                        `?type=${extParams.type}&activity_id=${activityId}&back_url=${backUrl}`;
                break;
            default:
                url = url + `?type=jump&activity_id=${activityId}`;
                return;
        }
        window.MPXWebviewBridge.navigateTo({
            url: url,
            success() {
                console.log('拉取中间页成功');
            },
            fail(err) {
                console.log('拉取中间页失败', err);
            }
        });
    }
}
export { H5Jump, PassengerJump, EsAppJump, DriverJump, HyDriverJump, WeixinJump, AlipayJump, DouyinJump, MiniprogramJump, AliprogramJump, DyprogramJump, HwfastappJump };
